import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScenarioCostSchedules = api(async function scenarioCostSchedules({
    scenarioId,
    variantId,
    setKey,
    first,
    after,
    search,
}) {
    return query(
        gql`
            query GetScenarioCostSchedules(
                $scenarioId: String!
                $variantId: String!
                $setKey: String!
                $first: Int
                $after: String
                $search: String
            ) {
                scenarioCostSchedules(
                    scenarioId: $scenarioId
                    variantId: $variantId
                    setKey: $setKey
                    first: $first
                    after: $after
                    search: $search
                ) {
                    items
                    endCursor
                    hasNextPage
                    totalCount
                    totals
                }
            }
        `,
        { scenarioId, variantId, setKey, first, after, search },
        { returns: "scenarioCostSchedules" }
    )
})
